import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    refreshChipCopy: (newCount: number) => string;
    refreshChipLabel: (newCount: number) => string;
    listAriaLabel: string;
    unreadEmptyListTitle: string;
    unreadEmptyListCta: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Text displayed in refresh chip showing new notification count */
            refreshChipCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (newCount: number): string => { return __intl__.intl().formatMessage({ id: "NotificationsList.refreshChipCopy.0?c=1w3teo8x3qb9k", defaultMessage: "{newCount, plural, one {new notification} other {new notifications}}" }, { newCount: newCount }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for refresh chip button */
            refreshChipLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (newCount: number): string => { return __intl__.intl().formatMessage({ id: "NotificationsList.refreshChipLabel.0?c=2gve607fmtnp", defaultMessage: "Refresh to load {newCount, plural, one {new notification} other {new notifications}}" }, { newCount: newCount }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for the notifications list */
            listAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationsList.listAriaLabel?c=1bmhy5j8pv1g6", defaultMessage: "Notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state title when filtering by unread */
            unreadEmptyListTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationsList.unreadEmptyListTitle?c=37kh30dkkhh1f", defaultMessage: "No unread notifications" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button to view all notifications from unread empty state */
            unreadEmptyListCta: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "NotificationsList.unreadEmptyListCta?c=2h9v6y3py76t3", defaultMessage: "View All" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
